export const subjectApi = {
    heading:[
        
        {
            head:"Subject ID"
        },
        {
            head:"Subject Name"
        },
        {
            head:"Short Name"
        },      
        {
            head:"Effective From"
        },
        {
            head:"Effective To"
        },
        {
            head:"Action"
        }
    ],
    data:[
       {
        subjectid:101,
        subjectname:"Emglish-1",
        shortname:"eng-1",        
        effectiveFrom:"06-06-2023",
        effectiveTo:"20-06-2023",
        action:"./assets/images/dashboards/adminDashboard/flexvalue/tableactionicon.png"
       },
       {
        subjectid:101,
        subjectname:"Emglish-1",
        shortname:"eng-1",        
        effectiveFrom:"06-06-2023",
        effectiveTo:"20-06-2023",
        action:"./assets/images/dashboards/adminDashboard/flexvalue/tableactionicon.png"
       },
       {
        subjectid:101,
        subjectname:"Emglish-1",
        shortname:"eng-1",        
        effectiveFrom:"06-06-2023",
        effectiveTo:"20-06-2023",
        action:"./assets/images/dashboards/adminDashboard/flexvalue/tableactionicon.png"
       },
       {
        subjectid:101,
        subjectname:"Emglish-1",
        shortname:"eng-1",        
        effectiveFrom:"06-06-2023",
        effectiveTo:"20-06-2023",
        action:"./assets/images/dashboards/adminDashboard/flexvalue/tableactionicon.png"
       },
       {
        subjectid:101,
        subjectname:"Emglish-1",
        shortname:"eng-1",        
        effectiveFrom:"06-06-2023",
        effectiveTo:"20-06-2023",
        action:"./assets/images/dashboards/adminDashboard/flexvalue/tableactionicon.png"
       },
       {
        subjectid:101,
        subjectname:"Emglish-1",
        shortname:"eng-1",        
        effectiveFrom:"06-06-2023",
        effectiveTo:"20-06-2023",
        action:"./assets/images/dashboards/adminDashboard/flexvalue/tableactionicon.png"
       },
       {
        subjectid:101,
        subjectname:"Emglish-1",
        shortname:"eng-1",        
        effectiveFrom:"06-06-2023",
        effectiveTo:"20-06-2023",
        action:"./assets/images/dashboards/adminDashboard/flexvalue/tableactionicon.png"
       },
       {
        subjectid:101,
        subjectname:"Emglish-1",
        shortname:"eng-1",        
        effectiveFrom:"06-06-2023",
        effectiveTo:"20-06-2023",
        action:"./assets/images/dashboards/adminDashboard/flexvalue/tableactionicon.png"
       },
       {
        subjectid:101,
        subjectname:"Emglish-1",
        shortname:"eng-1",        
        effectiveFrom:"06-06-2023",
        effectiveTo:"20-06-2023",
        action:"./assets/images/dashboards/adminDashboard/flexvalue/tableactionicon.png"
       },
       {
        subjectid:101,
        subjectname:"Emglish-1",
        shortname:"eng-1",        
        effectiveFrom:"06-06-2023",
        effectiveTo:"20-06-2023",
        action:"./assets/images/dashboards/adminDashboard/flexvalue/tableactionicon.png"
       },
      
      
     
      
     
   
       
    ]
}